export default __webpack_public_path__ + "static/media/luxWhite.d7cdd580.svg";